import React, { Component } from 'react';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LinkButton from '../LinkButton';
import { confirm } from 'react-bootstrap-confirmation';
import { MyGlobal, MyAlert } from '../GlobalContext';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';

export class CreateManifest extends Component {
    static displayName = CreateManifest.name;

    constructor(props) {
        super(props);
        var warehouseID = MyGlobal.warehouse;
        this.state = {
            alertMessage: "",
            loginAlertMessage: "",
            consignmentSummary: [],
            selectedCarrierId: 0,
            selectedCarrierName: "No Carrier Selected",
            scannedConsignment: "",
            tempManifestSessionId: "00000000-0000-0000-0000-000000000000",
            unmanifestedConsignments: [],
            passwordText: "",
            usernameText: "",
            staffId: "",
            supervisorUsers: [],
            displaySupervisorLogin: false
        };
        this.history = props.history;
        
    }

    componentDidMount() {
        
        if (this.props.location && this.props.location.state) {
            var consignmentSummary = this.props.location.state.ConsignmentSummary;
            var selectedCarrierId = this.props.location.state.SelectedCarrierId;
            var selectedCarrierName = this.props.location.state.SelectedCarrierName;
            var tempManifestSessionId = this.props.location.state.TempManifestSessionId;

            if (selectedCarrierId && selectedCarrierName) {
                this.setState({
                    selectedCarrierId: selectedCarrierId,
                    selectedCarrierName: selectedCarrierName
                });
            }
            if (tempManifestSessionId && consignmentSummary) {
                this.setState({
                    consignmentSummary: consignmentSummary,
                    tempManifestSessionId: tempManifestSessionId
                });
            }
            this.LoadUnmanifestedConsignments(selectedCarrierId);

        }
        else {
            if (MyGlobal.carrier_settings) {
                var globalCarrierSettings = JSON.parse(MyGlobal.carrier_settings);
                if (globalCarrierSettings) {
                    this.setState({
                        selectedCarrierId: globalCarrierSettings.selectedCarrierId,
                        selectedCarrierName: globalCarrierSettings.selectedCarrierName
                    });
                    this.LoadUnmanifestedConsignments(globalCarrierSettings.selectedCarrierId);
                }
            }
        }
       
    }
    goto(page) {
        this.history.push(page);
    }

    LoadUnmanifestedConsignments(carrierId) {
        this.setState({ loading: true });

        fetch(`api/Manifest/GetUnmanifestedConsignments?warehouseId=${MyGlobal.warehouse}&carrierId=${carrierId}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load consignments!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ unmanifestedConsignments : data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load consignments!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load consignments!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    addToTemporaryManifest() {

        var tempManifests = [];
        this.state.consignmentSummary.map(consignmentDetails => {
            var tempManifestDetails = {
                Docket: consignmentDetails.docket,
                Namecode: consignmentDetails.namecode,
                CarrierReference: consignmentDetails.carrierReference,
                Pallets: consignmentDetails.pallets,
                Cartons: consignmentDetails.cartons,
                CarrierId: consignmentDetails.carrierId,
                CarrierName: consignmentDetails.carrierName
            };
            tempManifests.push((tempManifestDetails))
        });

        const createTempManifestRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                SessionId: this.state.tempManifestSessionId,
                CarrierId: this.state.selectedCarrierId,
                WarehouseId: MyGlobal.warehouse,
                TempManifestDetails: tempManifests
            })
        };
        this.state.loading = true;
        fetch('api/Manifest/CreateManifestTempData', createTempManifestRequestOptions)
            .then(async response => {
                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Create Temporary Manifest Failed!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const sessionId = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ alertMessage: "", tempManifestSessionId: sessionId });
                        }
                        else {
                            this.setState({ alertMessage: "Create Temporary Manifest Failed!! " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Create Temporary Manifest Failed!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });

    }
    scanConsignment() {

        const displayConsignmentConfirmation = async (consignmentDetails) => {
            const confirmationResult = await confirm("Please confirm " + consignmentDetails.pallets + " Pallets and " + consignmentDetails.cartons + " Cartons");
            if (confirmationResult === true) {
                this.state.consignmentSummary.push(consignmentDetails);
                this.addToTemporaryManifest();
            }
            else {
                this.setState({ scannedConsignment: "" });
            }
        };

        if (this.state.scannedConsignment && this.state.scannedConsignment !== "") {


            const matchingConsignment = this.state.consignmentSummary.find((element) => {
                return element.carrierReference.trim() === this.state.scannedConsignment.trim();
            });

            if (matchingConsignment) {
                this.setState({ alertMessage: "Consignment : " + this.state.scannedConsignment + " already added to Summary" });
                return;
            }
            this.setState({ loading: true, alertMessage: "" });
            fetch(`api/Manifest/GetConsignmentDetails?carrierReference=${this.state.scannedConsignment.trim()}&warehouseId=${MyGlobal.warehouse}&carrierId=${this.state.selectedCarrierId}`)
                .then(async response => {

                    this.setState({ loading: false });

                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        console.error(errorText);
                        this.setState({ alertMessage: "Failed to load Consignment details!!" });
                    }
                    else {
                        const isJson = response.headers.get('content-type')?.includes('application/json');
                        const apiResponse = isJson ? await response.json() : null;
                        if (apiResponse) {

                            if (apiResponse.success) {

                                var consignments = apiResponse.data;
                                if (!consignments || consignments.length === 0) {
                                    this.setState({ alertMessage: "Failed to load Consignment details!!" });
                                    return;
                                }
                                else {
                                    for (let i = 0; i < consignments.length; i++) {

                                        const consignmentDetails = consignments[i];


                                        const matchingConsignment = this.state.consignmentSummary.find((element) => {
                                            return element.carrierReference.trim() === consignmentDetails.carrierReference.trim();
                                        });

                                        if (matchingConsignment) {
                                            this.setState({ alertMessage: "Consignment : " + consignmentDetails.carrierReference + " already added to Summary" });
                                            return;
                                        }
                                        else {
                                            if (consignmentDetails.carrierId.toString() !== this.state.selectedCarrierId.toString()) {
                                                this.setState({ alertMessage: "This consignment belongs to carrier : " + consignmentDetails.carrierName + " and can not be added to this manifest." });
                                                return;
                                            }
                                            else {
                                                if (consignmentDetails.cartons > 1) {
                                                    displayConsignmentConfirmation(consignmentDetails);
                                                } else {
                                                    this.state.consignmentSummary.push(consignmentDetails);
                                                    this.addToTemporaryManifest();
                                                }
                                               
                                            }

                                        }


                                    }
                                }
                            }
                            else {
                                this.setState({ alertMessage: "Failed to load Consignment details!! " + apiResponse.errorMessage });
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Consignment details!!" });
                        }
                    }
                })
                .catch(error => {
                    this.setState({ alertMessage: error });
                });
        }
    }
    removeConsignment(consignmentDetails) {
        var array = this.state.consignmentSummary;
        var index = array.indexOf(consignmentDetails)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ consignmentSummary: array });
        }
        this.addToTemporaryManifest();
    }
    
    addConsignment(consignmentDetails) {

        const matchingConsignment = this.state.consignmentSummary.find((element) => {
            return element.carrierReference.trim() === consignmentDetails.carrierReference.trim();
        });
        const displayConsignmentConfirmation = async (consignmentDetails) => {
            const confirmationResult = await confirm("Please confirm " + consignmentDetails.pallets + " Pallets and " + consignmentDetails.cartons + " Cartons");
            if (confirmationResult === true) {
                this.state.consignmentSummary.push(consignmentDetails);
                this.addToTemporaryManifest();
            }
            else {
                this.setState({ scannedConsignment: "" });
            }
        };

        if (matchingConsignment) {
            this.setState({ alertMessage: "Consignment : " + consignmentDetails.carrierReference + " already added to Summary" });
            return;
        }
        else {
            if (consignmentDetails.carrierId.toString() !== this.state.selectedCarrierId.toString()) {
                this.setState({ alertMessage: "This consignment belongs to carrier : " + consignmentDetails.carrierName + " and can not be added to this manifest." });
                return;
            }
            else {
                if (consignmentDetails.cartons > 1) {
                    displayConsignmentConfirmation(consignmentDetails);
                } else {
                    this.state.consignmentSummary.push(consignmentDetails);
                    this.addToTemporaryManifest();
                }

            }

        }
    }

    addAllConsignments() {
        this.state.unmanifestedConsignments.map(consignmentDetails => {

            const matchingConsignment = this.state.consignmentSummary.find((element) => {
                return element.carrierReference.trim() === consignmentDetails.carrierReference.trim();
            });
            if (matchingConsignment) {
                return;
            }
            else {
                if (consignmentDetails.carrierId.toString() !== this.state.selectedCarrierId.toString()) {
                    return;
                }
                else {
                    this.state.consignmentSummary.push(consignmentDetails);
                }

            }
        });
        this.addToTemporaryManifest();

    }

    completeManifest() {
        if (!this.state.consignmentSummary || this.state.consignmentSummary.length <= 0) {
            this.setState({ alertMessage: "There are no items on the manifest, the manifest will be deleted" });
        }
        else {

            const displayCreateManifestConfirmation = async () => {
                const confirmationResult = await confirm("Are you sure you want to complete the manifest ?");
                if (confirmationResult === true) {


                    const createManifestRequestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            SessionId: this.state.tempManifestSessionId,
                            CarrierId: this.state.selectedCarrierId,
                            WarehouseId: MyGlobal.warehouse,
                            ConsignmentSummary: this.state.consignmentSummary
                        })
                    };
                    this.state.loading = true;
                    fetch('api/Manifest/CreateManifest', createManifestRequestOptions)
                        .then(async response => {
                            this.state.loading = false;
                            // check for error response
                            if (!response.ok) {
                                const errorText = await response.text();
                                console.error(errorText);
                                this.setState({ alertMessage: "Create Manifest Failed!!" });
                            }
                            else {
                                const isJson = response.headers.get('content-type')?.includes('application/json');
                                const apiResponse = isJson ? await response.json() : null;
                                if (apiResponse) {
                                    const generatedManifestNumber = apiResponse.data;
                                    if (apiResponse.success) {
                                        this.setState({ alertMessage: apiResponse.message });
                                        this.navigateToCaptureSignature({ CarrierId: this.state.selectedCarrierId, ManifestNumber: generatedManifestNumber, CreateManifestResponse: apiResponse.message, consignmentSummary: this.state.consignmentSummary });
                                    }
                                    else {
                                        this.setState({ alertMessage: "Create Manifest Failed!! " + apiResponse.errorMessage });
                                    }
                                }
                                else {
                                    this.setState({ alertMessage: "Create Manifest Failed!!" });
                                }
                            }
                        })
                        .catch(error => {
                            this.setState({ alertMessage: error });
                        });


                }
                else {
                    this.setState({ scannedConsignment: "" });
                }

            };
            displayCreateManifestConfirmation();
        }

    }
    navigateToCaptureSignature(manifestDetails) {

        this.history.push({
            pathname: 'CaptureSignature',
            state: manifestDetails
        });
    }

    doLogin() {
        if (this.state.staffId == "" || this.state.passwordText == "") {
            this.setState({ loginAlertMessage: "Enter username and password" });
            return;
        }
      
        this.setState({ loading: true });

        fetch(`api/MXDock/SupervisorApproval?staffId=${this.state.staffId}&password=${this.state.passwordText}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ loginAlertMessage: "Login attempt failed!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.setState({ loginAlertMessage: "", displaySupervisorLogin: false });
                            this.addAllConsignments();
                        }
                        else {
                            this.setState({ loginAlertMessage: "Supervisor login in correct, please try again." });
                        }
                    }
                    else {
                        this.setState({ loginAlertMessage: "Supervisor login in correct, please try again." });
                    }
                }
            })
            .catch(error => {
                this.setState({ loginAlertMessage: error });
            });

    }

    loadUsers() {

        this.setState({
            loading: true,
            passwordText: "",
            usernameText: "",
            staffId: "", });

        fetch(`api/Manifest/GetSupervisors`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Supervisors." });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({
                                supervisorUsers: data, loginAlertMessage: "", displaySupervisorLogin : true
                            });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Supervisors.  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Supervisors." });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    renderDropdown() {
        return (<select
            className="form-select form-control"
            name="selUsername"
            aria-label=".form-select-lg example"
            onChange={(e) => {
                this.setState({ staffId: e.target.value, passwordText: "" });
            }}>
            {this.state.supervisorUsers.map(row =>
                <option key={row.id} value={row.id}>{row.staff_Name}</option>
            )}
        </select>)
    }

    render() {

        const handleConsignmentInputKeypress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.scanConsignment();
            }
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";

        let loginAlertMessage = this.state.loginAlertMessage;
        loginAlertMessage = loginAlertMessage != "" ? <MyAlert variant="danger">{loginAlertMessage}</MyAlert> : "";

        return <div className="container" >
            <Container>
                <Row className="mb-3">
                    <Col xs={9}>
                        <h5>Create Manifest</h5>
                        {alertMessage}
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "LoadCarriers" }}>Back</Link>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Carrier Name :</label>
                    </Col>
                    <Col xs={7}>
                        {this.state.selectedCarrierName}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Consignment :</label>
                    </Col>
                    <Col xs={7}>
                        <input ref="consignmentInput" className="form-control" value={this.state.scannedConsignment} onKeyPress={handleConsignmentInputKeypress}
                            onChange={(e) => {
                                this.setState({ scannedConsignment: e.target.value });
                            }} ></input>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.scanConsignment()} >Next</button>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.completeManifest()} >Complete</button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <label><b>Summary:</b> </label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="tableHolder hm-50vh mb-3">
                            {this.state.loading && <div> <em>Loading ... </em></div>}
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Connote</th>
                                        <th>Pallet</th>
                                        <th>Carton</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.consignmentSummary.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.carrierReference}</td>
                                            <td>{item.pallets}</td>
                                            <td>{item.cartons}</td>
                                            <td>
                                                <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.removeConsignment(item)} >Remove</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={6}>
                        <label> <b>Unmanifested Consignments : </b> {this.state.unmanifestedConsignments.length}</label>
                    </Col>
                    <Col xs={6}>
                        <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.loadUsers()} >Add All</button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="tableHolder hm-50vh mb-3">
                            {this.state.loading && <div> <em>Loading ... </em></div>}
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Connote</th>
                                        <th>Pallet</th>
                                        <th>Carton</th>
                                        <th>Namecode</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.unmanifestedConsignments.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.addConsignment(item)} >Add</button>
                                            </td>
                                            <td>{item.carrierReference}</td>
                                            <td>{item.pallets}</td>
                                            <td>{item.cartons}</td>
                                            <td>{item.namecode}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Modal show={this.state.displaySupervisorLogin} backdrop="static" centered>
                <Modal.Header>
                    <Modal.Title>Please login as a supervisor to Proceed</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        {loginAlertMessage}
                        {contents}
                        <div className="form-group">
                            <label htmlFor="selUsername">Username</label>
                            {this.renderDropdown()}
                        </div>

                        <div className="form-group">
                            <label htmlFor="txtPasword">Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="txtPasword"
                                id="txtPasword"
                                value={this.state.passwordText}
                                onChange={(e) => {
                                    this.setState({ passwordText: e.target.value });
                                }}
                            />
                        </div>

                        <div className="container">
                            <div className="row form-group">
                                <button type="button" className="btn btn-success col-12 mb-2" disabled={this.state.loading} onClick={() => { this.doLogin() }}>Proceed</button>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row form-group">
                                <button type="button" className="btn btn-danger col-12 mb-2" disabled={this.state.loading} onClick={() => this.setState({ displaySupervisorLogin: false })} >Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    }


}



